export function OutlineTemplateLink(props) {
  return (
    <a
      className="outline-template-link"
      onClick={(e) => {
        e.preventDefault();
        props.setValue(`Act 1:
Chapter 1:
Chapter 2:
Chapter 3:
Act 2:
Chapter 4:
Chapter 5:
etc...`);
      }}
    >
      Insert Template
    </a>
  );
}
